const messages = {
  en: {
    managePlan: "Manage Plan",
    changeSubscription: "Change Subscription",
    cancelSubscription: "Cancel Subscription",
    reactivate: "Reactivate",
  },
  fr: {
    managePlan: "Gérer le plan",
    changeSubscription: "Changer d'abonnement",
    cancelSubscription: "Annuler l'abonnement",
    reactivate: "Réactiver",
  },
};

export default messages;
